const getters = {
  getQueues: (state) => state.queues || [],
  getAccounts: (state) => state.accounts || [],
  isQueuesLoading: (state) => !!state.loading,
  getQueuesError: (state) => state.error,
  // Meaning Analysis Duration
  getMeaningAnalysisData: (state) => (widgetId) => {
    return state.meaningAnalysisWidgets?.[widgetId]?.data || null
  },
  isMeaningAnalysisLoading: (state) => (widgetId) => {
    return state.meaningAnalysisWidgets?.[widgetId]?.loading || false
  },
  getMeaningAnalysisError: (state) => (widgetId) => {
    return state.meaningAnalysisWidgets?.[widgetId]?.error || null
  },
  // Generic operational widgets
  getOperationalWidgetData: (state) => (widgetId) => {
    return state.operationalWidgets?.[widgetId]?.data || null
  },
  isOperationalWidgetLoading: (state) => (widgetId) => {
    return state.operationalWidgets?.[widgetId]?.loading || false
  },
  getOperationalWidgetError: (state) => (widgetId) => {
    return state.operationalWidgets?.[widgetId]?.error || null
  },
  
  // Time widgets
  getTimeWidgetData: (state) => (widgetId) => {
    return state.timeWidgets?.[widgetId]?.data || null
  },
  isTimeWidgetLoading: (state) => (widgetId) => {
    return state.timeWidgets?.[widgetId]?.loading || false
  },
  getTimeWidgetError: (state) => (widgetId) => {
    return state.timeWidgets?.[widgetId]?.error || null
  }
}
export default getters
